import { useEffect } from 'react'
import { useMap } from 'react-leaflet'

export function CenterToBounds({ bounds }: { bounds: L.LatLngBounds | null }) {
  const map = useMap()

  useEffect(() => {
    if (bounds) map.fitBounds(bounds)
  }, [bounds])
  return null
}
